import React from 'react';
import {
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Collapse,
    Skeleton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { trakrefBlue, Grey1 } from '../../color_utils';
import { trakrefFontFamilySemiBold } from '../../utils';
import { listTextStyle, activeReportIndicatorStyle, skeletonReportItems } from './utils';
import "./PowerBI.css"
import UserInfo from '../../UserInfo';

const removeButtonFocus = { '&:focus': { outline: 'none' } };

const ReportOptions = ({
    allReports,
    reportListExpanded,
    expandReportList,
    selectReport,
    searchIsOn,
    setSearchIsOn,
    filterSearch,
    handleSearch,
    determineSelectedReport,
    selectedReport,
    reportsLoading,
}) => (
    reportsLoading ? (
        skeletonReportItems.map((_, index) => (
            <div style={{ marginTop: index === 0 ? '4vh' : '1vh' }}>
                <Skeleton variant="rectangular" height={40} />
            </div>
        ))
    ) : (
        <List component="div" disablePadding sx={{ marginTop: '4vh' }}>
            {allReports.map((reportCategory, index) => (
               (reportCategory.render || UserInfo.isNativeAdminRole()) && (
                <>
                    <ListItem
                        disablePadding
                        key={index}
                        sx={{ background: index === 0 ? "#F6F6F6" : "#FFFFFF" }}
                        secondaryAction={
                            reportCategory.search ? (
                                <IconButton
                                    edge="end"
                                    aria-label="search"
                                    disabled={reportListExpanded !== index}
                                    onClick={() => setSearchIsOn(!searchIsOn)}
                                    sx={removeButtonFocus}
                                >
                                    <SearchIcon />
                                </IconButton>
                            ) : <></>
                        }
                    >
                        <ListItemButton
                            selected={reportListExpanded === index}
                            onClick={() => expandReportList(index)}
                        >
                            <ListItemText
                                primary={reportCategory.title}
                                primaryTypographyProps={listTextStyle}
                                sx={{
                                    '& .MuiListItemText-primary': { fontFamily: trakrefFontFamilySemiBold }
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                    {(reportCategory.search && searchIsOn && reportListExpanded === index) && (
                        <div>
                            <input
                                fullWidth
                                className="filterSearch"
                                type="text"
                                autocomplete="off"
                                placeholder='Search Reports...'
                                id="standard-basic"
                                value={filterSearch}
                                onChange={e => handleSearch(e.target.value)}
                            />
                        </div>    
                    )}
                    <Collapse in={reportListExpanded === index} timeout="auto" unmountOnExit>
                        {reportCategory.reports.map(childReport => (
                            <List component="div" disablePadding dense>
                                <ListItem
                                    key={childReport.name}
                                    sx={determineSelectedReport(childReport.id) ? { ...listTextStyle, ...activeReportIndicatorStyle } : listTextStyle}
                                >
                                    <ListItemButton
                                        sx={{ pl: 4 }}
                                        onClick={() => selectReport(reportCategory.type, childReport.id)}
                                    >
                                        <ListItemText
                                            primary={childReport.name}
                                            primaryTypographyProps={{
                                                ...listTextStyle,
                                                color: selectedReport.id === childReport.id ? trakrefBlue : Grey1
                                            }}
                                            sx={{
                                                '& .MuiListItemText-primary': { fontFamily: trakrefFontFamilySemiBold }
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            </List>
                        ))}
                    </Collapse>
                </>
               )
            ))}
        </List>
    )
);

export default ReportOptions;
